
// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { updatecustomer, updateuser, userService } from "../../services/AuthenticationService";
// import'./Profile.css';




// const MyAccount=()=>{
//   const userId = useSelector((state) => state.auth.userId); 
 
//     const [formData, setFormData] = useState({
//       name: "",
//       userName: "",
//       mobile: "",
//       email: "",
     
//     });
//       useEffect(() => {
//         if (userId) {
//           userService(userId)
//             .then((response) => {
//               setFormData(response);
//             })
//             .catch((error) => console.error("Error fetching profile:", error));
//         }
//       }, [userId]);


//       const handleChange = (e) => {
//         const { name, value} = e.target;
//         setFormData({
//           ...formData,
//           [name] : value,
//         });
//       };
//     console.log("formDataaaaaaaaa",formData)
//       const handleSubmit = async (e) => {
//         e.preventDefault();
//        // console.log("Form Submitted", formData);
//         try {
//           const response = await updatecustomer(formData);
//          // console.log("Profile updated:", response);
//           alert("Profile updated successfully!");
//         } catch (error) {
//           console.error("Error updating profile:", error);
//           alert("Failed to update profile.");
//         }
//       };
    
//     return(  <div className="account-page">
//         <section className="checkout-section">
//           <div className="account-form">
            
//                 <form onSubmit={handleSubmit} className="billing-form">
//                 <div className="col-md-7 heading-section ">
//                 <span className="subheading">Profile</span>
//                 </div>

//                    <div className="row align-items-end mt-5">
//                     <div className="col-md-12">
//                       <label>Full Name</label>
//                       <input 
//                       type="text" 
//                       name="fullName" 
//                       value={formData.name} 
//                       onChange={handleChange}
//                        className="form-control" />
//                     </div>
//                     <div className="col-md-12">
//                       <label>User Name</label>
//                       <input type="text"
//                        name="userName"
//                         value={formData.userName} 
//                         onChange={handleChange} 
//                         className="form-control" />
//                     </div>
                    
                    
//                     <div className="col-md-12">
//                       <label>Contact Number</label>
//                       <input type="text"
//                        name="phone" 
//                        value={formData.mobile} 
//                        onChange={handleChange} 
//                        className="form-control" />
//                     </div>
//                     <div className="col-md-12">
//                       <label>Email Address</label>
//                       <input type="email"
//                        name="email"
//                         value={formData.email} 
//                         onChange={handleChange}
//                          className="form-control" />
//                     </div>
//                     {/* <div className="col-md-12">
//                       <label>Password</label>
//                       <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} className="form-control" />
//                     </div> */}
                    
//                   </div> 
//                   <button type="submit"
//                    className="btn btn-primary btn-outline-primary rounded-0 mt-2" 
//                   > 
//                    Save changes
//                    </button>
//                 </form>
//                 <div>
             
//             </div>
//           </div>
//         </section>
//         </div>

//     )
// }
// export default MyAccount;

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  updatecustomer,
  userService,
} from "../../services/AuthenticationService";
import "./Profile.css";

const MyAccount = () => {
  const userId = useSelector((state) => state.auth.userId);

  const [formData, setFormData] = useState(null);
  const [originalUserName, setOriginalUserName] = useState("");

  useEffect(() => {
    if (userId) {
      userService(userId)
        .then((response) => {
          setFormData(response);
          setOriginalUserName(response.userName);
        })
        .catch((error) =>
          console.error("Error fetching profile:", error)
        );
    }
  }, [userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.userName !== originalUserName) {
      alert("You cannot change your username.");
      return;
    }

    try {
      const response = await updatecustomer(formData);
      alert("Profile updated successfully!");
    } catch (error) {
      console.error(
        "Error updating profile:",
        error.response?.data || error.message
      );
      alert("Failed to update profile.");
    }
  };

  if (!formData) return <div>Loading...</div>;

  return (
    <div className="account-page">
      <section className="checkout-section">
        <div className="account-form">
          <form onSubmit={handleSubmit} className="billing-form">
            <div className="col-md-7 heading-section">
              <span className="subheading">Profile</span>
            </div>

            <div className="row align-items-end mt-5">
              <div className="col-md-12">
                <label>Full Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name || ""}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

              <div className="col-md-12">
                <label>User Name</label>
                <input
                  type="text"
                  name="userName"
                  value={formData.userName || ""}
                  className="form-control"
            
                />
                    {/* {userNameError && (
                  <small className="text-danger">{userNameError}</small>
                )} */}
              </div>

              <div className="col-md-12">
                <label>Contact Number</label>
                <input
                  type="text"
                  name="mobile"
                  value={formData.mobile || ""}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

              <div className="col-md-12">
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email || ""}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-outline-primary rounded-0 mt-2"
            >
              Save changes
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default MyAccount;
